import { FormFieldComponentProps } from "./FormFieldComponent";
import { FormInput } from "semantic-ui-react";

export const NewPasswordInputComponent = (props: {
  props: PasswordInputComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <FormInput
      fluid
      label={props.props.label}
      required={props.props.required}
      placeholder={props.props.placeholder}
      type="password"
      value={props.data[props.props.key]}
      onChange={(e) =>
        props.setData({ ...props.data, [props.props.key]: e.target.value })
      }
    />
  );
};

export type PasswordInputComponentProps = {
  type: "password";
  key: string;
  label: string;
  required: boolean;
  placeholder: string;
};
